import React from "react";
import productimg from "../Image/Untitled design - 2025-01-15T083142.916.png";
import img1 from "../Image/Rectangle 34625569.png";
import "./Home.css";
import { Link, Navigate, useNavigate } from "react-router-dom";

function Molywarm() {
  const navigate = useNavigate()
  const backnavi = () => {
    navigate(-1)
  }
  return (
    <div>
      <div className="container-fluid home-banner-div1">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div>
                <img src={img1} className="img-fluid" alt="" />
              </div>
            </div>
            <div className="col-lg-7 home-banner-col2-div1">
              <div className="home-banner-col2-text11">
                <h1>Optimal wax found! Time to shred!</h1>
                <div className="row">
                  <div className="col-12">
                    <div className="home-banner-btn1 ">
                      <Link to="/intermediate">
                        <div className="product-card-div1 ">
                          <div className="product-image-div1">
                            <img src={productimg} className="" />
                          </div>
                          <div className="product-text-div1">
                            <h2>CERAMIC MOLY Warm Iron On Wax</h2>
                            <p>
                              Air temperature Range: 10°C to -4°C or 50°F to
                              25°F / <br /> Snow temperature Range: 0°C to -6°C
                              or 32°F to 21°F
                            </p>
                                                                                    <Link href=""><h3>View Product </h3></Link>
                            
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="next-btn-div1">
                <Link onClick={backnavi}>
                                    <div className="next-btn1">
                                      <svg
                                        class="mr-3"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="11"
                                        height="16"
                                        viewBox="0 0 11 16"
                                        fill="none"
                                      >
                                        <path
                                          d="M9 14L3 8L9 2"
                                          stroke="rgba(0, 0, 0, 0.80)"
                                          stroke-width="4"
                                          stroke-linecap="round"
                                        />
                                      </svg>{" "}
                                      Back
                                    </div>
                                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Molywarm;
